export interface DiagnosticoData {
  nome: string
  whatsapp: string
  email: string
  condicoes_saude: string[]
  respostas: Record<string, boolean>
  experiencia_oleos: string
  prontidao: string
  obstaculo: string
  interesses: string[]
  oleos_indicados: string[]
  status: string
  data_hora: string
}

export interface Oleo {
  nome: string
  emoji: string
  beneficio: string
}

export const CONDICOES_SAUDE = [
  'Nenhuma',
  'Gestante',
  'Amamentando',
  'Diabética(o)',
  'Hipertensa(o)',
  'Depressão',
  'Ansiedade crônica',
  'Alergias respiratórias',
  'Sensibilidade na pele',
  'Hiperatividade',
  'TDAH',
  'Autismo',
  'Doença autoimune',
  'Epilepsia',
  'Endometriose',
  'Menopausa',
]

export const PERGUNTAS = [
  { id: 'sono', texto: 'Você tem dificuldade para dormir, acorda no meio da noite ou não consegue ter um sono realmente reparador?', oleos: ['Lavanda'] },
  { id: 'disposicao', texto: 'Você acorda cansado(a), sem energia ou com sensação de peso no corpo?', oleos: ['Hortelã-Pimenta'] },
  { id: 'foco', texto: 'Você tem dificuldade de manter o foco e se distrai com facilidade?', oleos: ['Limão Siciliano', 'Hortelã-Pimenta'] },
  { id: 'memoria', texto: 'Você percebe que está esquecendo coisas importantes ou se perde no meio das tarefas?', oleos: ['Olíbano'] },
  { id: 'ansiedade', texto: 'Você sente sintomas de ansiedade como mente acelerada, aperto no peito ou coração disparado?', oleos: ['Mix para Estabilidade', 'Copaíba', 'Tangerina'] },
  { id: 'peso', texto: 'Seu peso oscila com frequência ou você sente que come por ansiedade ou frustração?', oleos: ['Mix Metabólico', 'Tangerina', 'Limão Siciliano'] },
  { id: 'dores', texto: 'Você sente dores de cabeça frequentes ou tensão constante no pescoço e ombros?', oleos: ['Hortelã-Pimenta', 'Mix para Tensão e Dores', 'Copaíba'] },
  { id: 'medicamentos', texto: 'Você faz uso contínuo de medicamentos para dor, ansiedade, inflamação ou estresse?', oleos: ['Copaíba', 'Olíbano', 'Mix para Estabilidade'] },
  { id: 'inflamacoes', texto: 'Você tem alergias, inflamações ou algum problema que não melhora mesmo cuidando da saúde?', oleos: ['Copaíba', 'Olíbano'] },
  { id: 'intestino', texto: 'Seu intestino é irregular, preso, solto ou não funciona diariamente?', oleos: ['Mix Digestivo'] },
  { id: 'vergonha', texto: 'Você já deixou de compartilhar ideias por medo do julgamento?', oleos: ['Copaíba', 'Mix Imunidade'] },
  { id: 'culpa', texto: 'Você sente que carrega responsabilidades que nem sempre são suas?', oleos: ['Copaíba', 'Limão Siciliano', 'Hortelã-Pimenta'] },
  { id: 'apatia', texto: 'Você sente indiferença, desânimo ou sensação de \'tanto faz\'?', oleos: ['Mix Imunidade', 'Tangerina'] },
  { id: 'tristeza', texto: 'Você revive lembranças tristes com frequência?', oleos: ['Mix Respiratório', 'Tangerina', 'Hortelã-Pimenta'] },
  { id: 'medo', texto: 'Você evita mudanças importantes por medo do desconhecido?', oleos: ['Mix para Estabilidade', 'Lavanda', 'Hortelã-Pimenta'] },
  { id: 'escassez', texto: 'Você sente comparação, ciúme ou frustração quando vê alguém conquistando algo que deseja?', oleos: ['Mix para Estabilidade', 'Tangerina', 'Limão Siciliano'] },
  { id: 'raiva', texto: 'Você se irrita facilmente com coisas pequenas?', oleos: ['Mix para Estabilidade'] },
  { id: 'orgulho', texto: 'Você tem dificuldade em pedir ajuda ou desculpas?', oleos: ['Mix Respiratório', 'Hortelã-Pimenta'] },
  { id: 'estagnacao', texto: 'Você sente que está travado(a) e repetindo ciclos emocionais?', oleos: ['Mix para Estabilidade', 'Mix Imunidade', 'Hortelã-Pimenta'] },
  { id: 'desequilibrio', texto: 'Você sente que sua vida emocional está te desequilibrando nos últimos dias?', oleos: ['Mix para Estabilidade', 'Copaíba', 'Olíbano', 'Hortelã-Pimenta', 'Tangerina'] },
]

export const OPCOES_EXPERIENCIA = [
  'Nunca experimentei',
  'Experimentei e gostei, mas não mantive o hábito',
  'Uso eventualmente',
  'Uso regularmente e já vi resultados',
  'Me sinto inseguro(a) e tenho muitas dúvidas',
]

export const OPCOES_PRONTIDAO = [
  'Estou pronto(a) e quero começar o quanto antes',
  'Tenho interesse, mas preciso entender melhor antes de decidir',
  'Estou curioso(a), mas não é prioridade agora',
  'Só quero entender, ainda não estou pensando em investir',
]

export const OPCOES_OBSTACULOS = [
  'Não sinto obstáculo — tudo que é bom para mim eu uso',
  'Falta de tempo para criar novos hábitos',
  'Dificuldade em saber por onde começar',
  'Questão financeira no momento',
  'Já tentei várias coisas e não mantive constância',
  'Não sei se realmente vai funcionar para mim',
]

export const OPCOES_INTERESSES = [
  'Só quero focar no meu bem-estar por agora',
  'Quero aprender mais sobre óleos essenciais',
  'Tenho interesse em indicar para outras pessoas',
  'Quero trabalhar com óleos essenciais e ter uma renda extra',
  'Todas as anteriores',
]

export const OLEOS_INFO: Record<string, Oleo> = {
  'Lavanda': { nome: 'Lavanda', emoji: '💜', beneficio: 'Relaxamento e sono' },
  'Hortelã-Pimenta': { nome: 'Hortelã-Pimenta', emoji: '🌿', beneficio: 'Energia e foco' },
  'Limão Siciliano': { nome: 'Limão Siciliano', emoji: '🍋', beneficio: 'Detox e clareza mental' },
  'Olíbano': { nome: 'Olíbano', emoji: '🟤', beneficio: 'Memória e inflamação' },
  'Copaíba': { nome: 'Copaíba', emoji: '🌳', beneficio: 'Inflamação e proteção' },
  'Tangerina': { nome: 'Tangerina', emoji: '🍊', beneficio: 'Alegria e leveza' },
  'Melaleuca': { nome: 'Melaleuca', emoji: '🌿', beneficio: 'Pele sensível' },
  'Mix para Estabilidade': { nome: 'Mix para Estabilidade', emoji: '⚖️', beneficio: 'Equilíbrio e estabilidade emocional' },
  'Mix para Aterramento': { nome: 'Mix para Aterramento', emoji: '⚖️', beneficio: 'Aterramento e equilíbrio' },
  'Mix Metabólico': { nome: 'Mix Metabólico', emoji: '⚡', beneficio: 'Metabolismo e peso' },
  'Mix para Tensão e Dores': { nome: 'Mix para Tensão e Dores', emoji: '💙', beneficio: 'Alívio de tensão e dores' },
  'Mix Digestivo': { nome: 'Mix Digestivo', emoji: '🫧', beneficio: 'Digestão e intestino' },
  'Mix Imunidade': { nome: 'Mix Imunidade', emoji: '🛡️', beneficio: 'Proteção imunológica' },
  'Mix Respiratório': { nome: 'Mix Respiratório', emoji: '🌬️', beneficio: 'Suporte respiratório e emocional' },
  'Mix Mensal Feminino': { nome: 'Mix Mensal Feminino', emoji: '🌸', beneficio: 'Saúde e equilíbrio feminino' },
}
